module.exports = __webpack_public_path__ + "static/media/Gotham-Light.728d4f00.eot";


//////////////////
// WEBPACK FOOTER
// ./src/theme/fonts/Gotham-Light.eot
// module id = 873
// module chunks = 40